module.exports = __webpack_public_path__ + "static/media/post-08.7c6a5bd7.jpg";